import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A 19-inch server rack: a black cabinet of stacked servers behind a vented
// front, each unit showing a strip of status LEDs, with a cable bundle dropping
// down one side. The compute load that draws the power.
const CABINET = "#34383e";
const CABINET_DK = "#23262b";
const UNIT = "#454b52";
const LED_B = "#3aa0d0";
const LED_G = "#3fae5a";
const CABLE = "#23232a";

export const serverRack = defineModel({
  id: "server-rack",
  batchId: "electric",
  name: "Server rack",
  tags: ["prop", "electric", "power", "compute", "datacenter", "server"],
  summary: "A 19-inch rack of servers with status LEDs.",
  footprint: 0.3,
  parts(): Part[] {
    const parts: Part[] = [
      // Cabinet shell.
      { geometry: new THREE.BoxGeometry(0.46, 1.1, 0.5), color: CABINET, position: [0, 0.55, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.06, 0.54), color: CABINET_DK, position: [0, 1.11, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.06, 0.54), color: CABINET_DK, position: [0, 0.03, 0] },
    ];
    // Eight server units stacked, each with a LED strip.
    for (let i = 0; i < 8; i++) {
      const y = 0.16 + i * 0.115;
      parts.push({ geometry: new THREE.BoxGeometry(0.4, 0.09, 0.02), color: UNIT, position: [0, y, 0.25] });
      const led = i % 2 === 0 ? LED_B : LED_G;
      parts.push({ geometry: new THREE.BoxGeometry(0.04, 0.03, 0.02), color: led, position: [-0.15, y, 0.27] });
      parts.push({ geometry: new THREE.BoxGeometry(0.02, 0.03, 0.02), color: i % 3 === 0 ? LED_G : LED_B, position: [-0.08, y, 0.27] });
    }
    // Cable bundle dropping down one rear side.
    parts.push({ geometry: new THREE.CylinderGeometry(0.04, 0.04, 0.9, 8), color: CABLE, position: [0.2, 0.6, -0.22] });
    return parts;
  },
  animations: [],
});
